
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vacancies",
      function () {
        return require("private-next-pages/vacancies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vacancies"])
      });
    }
  